const setFiltros = (tipo,valor) =>{
    localStorage.setItem('filtro_tipo',tipo);
    localStorage.setItem('filtro_valor',valor);
    return true;
};
export default setFiltros